import { Link, makeStyles, Typography, Grid } from '@material-ui/core';
import { Email, Language, LocationOn, Phone } from '@material-ui/icons';
import React from 'react';

const useStyles = makeStyles((theme) => ({
    communication: {
        marginTop: 9,
        marginRight: 8,
        marginBottom: -9,
        color: theme.palette.primary.main,
    },
    small: {
        width: theme.spacing(33),
        height: theme.spacing(44),
    },
    smallMelas: {
        width: theme.spacing(35),
        height: theme.spacing(27),
    },
}));



export const IQSProfil = ({ activeDescription }: { activeDescription: number }) => {
    const classes = useStyles()

    return (
        <React.Fragment>
            {activeDescription === 1 ?
                <React.Fragment>
                    <Typography variant='h5'>Η Εταιρεία</Typography>
                    <p>
                        <Typography align='justify'>
                            <p>
                                Το IQS ιδρύθηκε το 2004 με σκοπό να παρέχει υπηρεσίες επιθεώρησης, πιστοποίησης και εκπαίδευσης σύμφωνα με αναγνωρισμένα πρότυπα ποιότητας (GLOBALGAP, AGRO, ISO 9001, ISO 22000, ISO 14000). Στα πλαίσια της λειτουργίας του ως φορέας πιστοποίησης το IQS:
                                <ul>
                                    <li>
                                        Διαπιστεύθηκε από το Εθνικό Συμβούλιο Διαπίστευσης (ΕΣΥΔ) ως προς το πρότυπο ΕΛΟΤ ΕΝ 17065 με πεδίο εφαρμογής το GLOBALGAP
                                    </ li>
                                    <li>
                                        Διαπιστεύθηκε από το Εθνικό Συμβούλιο Διαπίστευσης (ΕΣΥΔ) ως προς το ISO 17021, για την πιστοποίηση Συστημάτων Ολοκληρωμένης Διαχείρισης σύμφωνα με τα AGRO 2.1 και AGRO 2.2
                                    </ li>
                                    <li>
                                        Aναγνωρίστηκε από το Υπουργείο Αγροτικής Ανάπτυξης και Τροφίμων ως φορέας πιστοποίησης σύμφωνα με τα AGRO 2.1 και AGRO 2.2  με Υπουργική Απόφαση υπ.αριθμ. 332846/19-10-09 (ΦΕΚ Β’ 2544/30-12-09).
                                    </ li>
                                </ul>
                            </p>
                        </Typography>
                    </p>
                    {/* <p>
                        <Typography variant='h6'>Γενικά στοιχεία</Typography>
                        <Grid container>
                            <Grid item sm={3}>
                                <Link href='http://www.bio-hellas.gr/el/%CE%91%CF%81%CF%87%CE%B9%CE%BA%CE%AE/tabid/58/Default.aspx'> <img src="/BIOHELLAS.jpg" alt="logo" className={classes.small} /> </Link>
                            </Grid>
                            <Grid item sm={9}>
                                <Typography align={"left"}>
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    Α/Α ΦΟΡΕΑ: 2 <br />
                                    ΣΥΝΤΟΝΙΣΤΗΣ: ΟΧΙ <br />
                                    ΕΠΩΝΥΜΙΑ ΦΟΡΕΑ: ΙΝΣΤΙΤΟΥΤΟ ΕΛΕΓΧΟΥ ΒΙΟΛΟΓΙΚΩΝ ΠΡΟΙΟΝΤΩΝ Α.Ε. <br />
                                    ΣΥΝΤΟΜΟΓΡΑΦΙΑ ΦΟΡΕΑ: ΒΙΟΕΛΛΑΣ <br />
                                </Typography>
                            </Grid>
                        </Grid>
                    </p> */}
                    {/* <p>
                        <Typography variant='h6'>Συνοπτική παρουσίαση δικαιούχου φορέα</Typography>
                        <Typography align='justify'>
                           
                        </Typography>
                    </p> */}
                    {/* <p>
                        <Typography variant='h6'>Επικοινωνία</Typography>
                        <Typography align='left'>
                            <LocationOn className={classes.communication} /> ΕΛ.ΒΕΝΙΖΕΛΟΥ 8, T.K. 55133, ΚΑΛΑΜΑΡΙΑ ΘΕΣ/ΝΙΚΗ <br />
                            <Phone className={classes.communication} /> ΤΗΛΕΦΩΝΟ ΕΠΙΚΟΙΝΩΝΙΑΣ: 2310029123 <br />
                            <Email className={classes.communication} /> <Link href='mailto:thessaloniki@bio-hellas.gr'>thessaloniki@bio-hellas.gr</Link> <br />
                            <Language className={classes.communication} /> <Link href='http://www.bio-hellas.gr/el/%CE%91%CF%81%CF%87%CE%B9%CE%BA%CE%AE/tabid/58/Default.aspx'>Ιστοσελίδα</Link>
                        </Typography>
                    </p> */}
                </React.Fragment>
                : null
            }

            {activeDescription === 2 ?
                <React.Fragment>
                    <Typography variant='h5'>Στόχοι του IQS είναι:</Typography>
                    <p>
                        <Typography align='justify'>
                            <p>
                                1. Η εκπαίδευση και κατάρτιση  σύμφωνα με κανονισμούς, τεχνικές προδιαγραφές, εθνικά, κοινοτικά ή / και ιδιωτικά πρότυπα ποιότητας αναγνωρισμένα από την αγορά για προϊόντα και συστήματα ποιότητας.
                            </p>
                            <p>
                                2. Εξασφάλιση μόνον κατάλληλα εκπαιδευμένου και έμπειρου προσωπικού ως εισηγητές των καταρτίσεων.
                            </p>
                            <p>
                                3. Η συνεχής βελτίωση των υπηρεσιών και της αποτελεσματικότητας των εκπαιδεύσεων - καταρτίσεων.
                            </p>
                            <p>
                                4. Ανταπόκριση στις απαιτήσεις των πελατών με τον πλέον αποδοτικό και οικονομικό γι’ αυτούς τρόπο.
                            </p>
                        </Typography>
                    </p>
                    {/* <p>
                        <Typography variant='h6'>Γενικά στοιχεία</Typography>
                        <Grid container>
                            <Grid item sm={3}>
                                <Link href='http://www.melasoil.gr/'> <img src="/Melas.png" alt="logo" className={classes.smallMelas} /></Link>
                            </Grid>
                            <Grid item sm={9}>
                                <Typography align='left'>
                                    <br />
                                    <br />
                                    <br />
                                    Α/Α ΦΟΡΕΑ: 3 <br />
                            ΣΥΝΤΟΝΙΣΤΗΣ: ΟΧΙ <br />
                            ΕΠΩΝΥΜΙΑ ΦΟΡΕΑ: ΜΕΛΑΣ - Ελαιουργία Επιδαύριας Γης<br />
                            ΣΥΝΤΟΜΟΓΡΑΦΙΑ ΦΟΡΕΑ: ΜΕΛΑΣ<br />
                                </Typography>
                            </Grid>
                        </Grid>
                    </p> */}
                    {/* <p>
                        <Typography variant='h6'>Συνοπτική παρουσίαση δικαιούχου φορέα</Typography>
                        <Typography align='justify'>
                            Οι ελαιώνες, το ελαιοτριβείο και η μονάδα τυποποίησης της οικογένειας ΜΕΛΑ βρίσκονται συγκεντρωμένα στο Λυγουριό του σημερινού Δήμου Επιδαύρου (τέως Ασκληπιείου) που ανήκει στο Νομό Αργολίδας. Η επιχείρηση ιδρύεται στις 21/11/1994 με την επωνυμία ΕΥΑΓΓΕΛΟΣ Β. ΜΕΛΑΣ με αντικείμενο την τυποποίηση και εμπορία ελαιολάδου. Την ίδια μέρα εγγράφεται και στο Βιοτεχνικό Επιμελητήριο Αργολίδος, με αριθμό μητρώου 15937 (αριθμός δήλωσης έναρξης 3469/21-11-94, ΔΟΥ Ναυπλίου). Σε διάστημα ενός έτους από την ίδρυση της μονάδας και σε 7 μήνες ουσιαστικής λειτουργίας, κατόρθωσε να εξοπλιστεί μηχανολογικά, να οργανωθεί στην αγοραπωλησία ελαιολάδου και να εξάγει στην Ευρώπη – Η.Π.Α. – Καναδά τις πρώτες ποσότητες ελαιολάδου. Αυτή τη στιγμή το Melas Oil εξάγεται σε 26 χώρες, από την Αμερική μέχρι την Ιαπωνία. Παράλληλα, οργανώνει τα υπόλοιπα τμήματα, ώστε να ανταποκριθεί στις αυξανόμενες ανάγκες του αγοραστικού κοινού. Από την αρχή στηρίχτηκε στο πλεονέκτημα της υψηλής ποιότητας και από το 1994 καλλιεργεί με βιολογικές μεθόδους τον ιδιόκτητο ελαιώνα εκτάσεως 50 στρεμμάτων με 750 ελαιόδεντρα. Ήταν η πρώτη βιολογική καλλιέργεια στην περιοχή και μια από τις πρώτες στην Ελλάδα, ενώ πιστοποιήθηκε από την BIO HELLAS το 1998, με αριθμό πιστοποιητικού 360065. Θα πρέπει να τονιστεί ότι η ΜΕΛΑΣ Ελαιουργεία Ασκληπιείου είναι μια από τις λίγες επιχειρήσεις που έχουν το δικαίωμα να κάνουν εξαγωγές ελαιολάδου γιατί πληρούν όλες τις προϋποθέσεις κατά την παραγωγική διαδικασία, τόσο για τις απαιτήσεις της Ευρωπαϊκής Ένωσης, όσο και για τις απαιτήσεις των Τρίτων Χωρών (Κίνα, Η.Π.Α., Καναδάς, Ιαπωνία κλπ). Το 2005 σχεδιάζεται η δημιουργία της υφιστάμενης μονάδας παραγωγής, τυποποίησης και διοίκησης της μονάδας μέσα από την υπαγωγή στον αναπτυξιακό νόμο 1257 διαχείρισης του υπουργείου Αγροτικής Ανάπτυξης και Τροφίμων. Η υλοποίηση της επένδυσης ξεκινά το 2007 μετά την έγκριση του επενδυτικού σχεδίου κι ολοκληρώνεται το 2008. Η νέα μονάδα παραγωγής και τυποποίησης, η οποία αποτελεί υπόδειγμα, σήμερα είναι επισκέψιμη τόσο από φορείς κι επιχειρήσεις του εξωτερικού, με δραστηριότητα στο χώρο του ελαιολάδου, όσο κι από ιδιώτες και ιδρύματα με ενδιαφέρον στην εκμάθηση του κύκλου παραγωγής ελαιολάδου.
                        </Typography>
                    </p>
                    <p>
                        <Typography variant='h6'>Επικοινωνία</Typography>
                        <Typography align='left'>
                            <LocationOn className={classes.communication} /> Χ.& Α. ΣΑΡΡΗ 3 ΑΓ.ΒΛΑΣΣΗΣ, T.K. 21052, ΕΠΙΔΑΥΡΟΣ<br />
                            <Phone className={classes.communication} /> ΤΗΛΕΦΩΝΟ ΕΠΙΚΟΙΝΩΝΙΑΣ: 2753023543 <br />
                            <Email className={classes.communication} /> <Link href='mailto:info@melasoil.gr'>info@melasoil.gr</Link> <br />
                            <Language className={classes.communication} /> <Link href='http://www.melasoil.gr/'>Ιστοσελίδα</Link>
                        </Typography>
                    </p> */}
                </React.Fragment>
                : null
            }

            {activeDescription === 3 ?
                <React.Fragment>
                    <p>
                        <Typography variant='h6'>Ανθρώπινο Δυναμικό</Typography>
                        <p>
                            <Typography align='justify'>
                                <p>
                                    Η ομάδα που υλοποιεί τα προγράμματα εκπαιδεύσεων - καταρτίσεων αποτελείται από ικανά άτομα με:
                                    <ul >
                                        <li>
                                            τεκμηριωμένη εμπειρία
                                        </li>
                                        <li>
                                            τεχνογνωσία  στα  συστήματα διαχείρισης ποιότητας
                                        </li>
                                        <li>
                                            σύνδεση με την ευρύτερη αγορά του αγροδιατροφικού τομέα και της εστίασης
                                        </li>
                                        <li>
                                            συνεχή επιμόρφωση και παρακολούθηση των εξελίξεων στην επιστήμη και τεχνολογία για τη βιώσιμη ανάπτυξη και την προστασία του περιβάλλοντος
                                        </li>
                                    </ul>
                                </p>

                            </Typography>
                        </p>
                        {/* <Typography align='left'>
                            Α/Α ΦΟΡΕΑ: 4 <br />
                            ΣΥΝΤΟΝΙΣΤΗΣ: ΟΧΙ <br />
                            ΕΠΩΝΥΜΙΑ ΦΟΡΕΑ: ΕΘΝΙΚΟ ΚΕΝΤΡΟ ΕΡΕΥΝΑΣ ΦΥΣΙΚΩΝ ΕΠΙΣΤΗΜΩΝ ‘‘ΔΗΜΟΚΡΙΤΟΣ’’<br />
                            ΣΥΝΤΟΜΟΓΡΑΦΙΑ ΦΟΡΕΑ: ΔΗΜΟΚΡΙΤΟΣ<br />
                            ΕΠΩΝΥΜΙΑ ΚΥΡΙΟΥ ΦΟΡΕΑ ΣΤΟΝ ΟΠΟΙΟ ΑΝΗΚΕΙ: ΥΠ. ΠΑΙΔΕΙΑΣ<br />
                        </Typography> */}
                    </p>
                    {/* <p>
                        <Typography variant='h6'>Συνοπτική παρουσίαση δικαιούχου φορέα</Typography>
                        <Typography align='justify'>
                            Το Εθνικό Κέντρο Έρευνας Φυσικών Επιστημών “ΔΗΜΟΚΡΙΤΟΣ” ιδρύθηκε το
                            1959 ως αποκεντρωμένη δημόσια υπηρεσία. Το Ινστιτούτο Νανοεπιστήμης
                            και Νανοτεχνολογίας (ΙΝΝ) είναι ένα από τα παλαιότερα Ινστιτούτα του
                            ΕΚΕΦΕ &quot;Δημόκριτος&quot;. Στην παρούσα του μορφή διαμορφώθηκε το έτος 2013
                            ως ένα από τα 5 Ινστιτούτα του ΕΚΕΦΕ “Δημόκριτος”. Ο συνδυασμός της
                            πολύ υψηλής ποιότητας του επιστημονικού προσωπικού και της άριστης
                            υποδομής έχει αποφέρει σημαντικές ερευνητικές διακρίσεις και εξωτερική
                            χρηματοδότηση. Η Μονάδα Σταθερών Ισοτόπων και Ραδιοάνθρακα του
                            Ινστιτούτου Νανοεπιστήμης και Νανοτεχνολογίας του ΕΚΕΦΕ “ΔΗΜΟΚΡΙΤΟΣ”
                            έχει κατορθώσει να δημιουργήσει και να αναπτύξει μια τεχνογνωσία υψηλού
                            επιπέδου σε ένα μεγάλο φάσμα ερευνητικών δραστηριοτήτων και υπηρεσιών
                            βασιζόμενη στη χρήση της ισοτοπικής γεωχημείας.
                        </Typography>
                    </p> */}
                    {/* <p>
                        <Typography variant='h6'>Επικοινωνία</Typography>
                        <Typography align='left'>
                            <LocationOn className={classes.communication} />  ΠΑΤΡΙΑΡΧΟΥ ΙΩΑΚΕΙΜ ΚΑΙ ΝΕΑΠΟΛΕΟΣ, T.K. 15341, ΑΘΗΝΑ<br />
                            <Phone className={classes.communication} /> ΤΗΛΕΦΩΝΟ ΕΠΙΚΟΙΝΩΝΙΑΣ: 2106503002 <br />
                            <Email className={classes.communication} /> <Link href='mailto:communications@central.demokritos.gr'>communications@central.demokritos.gr</Link> <br />
                            <Language className={classes.communication} /> <Link href='http://www.demokritos.gr/el/'>Ιστοσελίδα</Link>
                        </Typography>
                    </p> */}
                </React.Fragment>
                : null
            }


            {/* {activeDescription === 5 ?
                <React.Fragment>
                    <p>
                        <Typography variant='h6'>Γενικά στοιχεία</Typography>
                        <Typography align='left'>
                            Α/Α ΦΟΡΕΑ: 6 <br />
                            ΣΥΝΤΟΝΙΣΤΗΣ: ΟΧΙ <br />
                            ΕΠΩΝΥΜΙΑ ΦΟΡΕΑ: ΕΡΓΑΣΤΗΡΙΟ ΧΗΜΕΙΑΣ ΤΡΟΦΙΜΩΝ<br />
                            ΣΥΝΤΟΜΟΓΡΑΦΙΑ ΦΟΡΕΑ: ΧΤΤΧΕΚΠΑ<br />
                            ΕΠΩΝΥΜΙΑ ΚΥΡΙΟΥ ΦΟΡΕΑ ΣΤΟΝ ΟΠΟΙΟ ΑΝΗΚΕΙ: ΤΜΗΜΑ ΧΗΜΕΙΑΣ ΤΟΜΕΑΣ 2 ΕΚΠΑ<br />
                        </Typography>
                    </p>
                    <p>
                        <Typography variant='h6'>Συνοπτική παρουσίαση δικαιούχου φορέα</Typography>
                        <Typography align='justify'>
                            Το ΕΚΠΑ είναι ΝΠΔΔ. Το τμήμα Χημείας ανήκει στο ΕΚΠΑ και το εργαστήριο χημείας τροφίμων ανήκει στον τομέα ΙΙ του τμήματος Χημείας. Το 1922 το Τμήμα Χημείας του ΕΚΠΑ απέκτησε την Έδρα της Χημείας Τροφίμων και είναι από τα πρώτα τμήματα της Χημείας Τροφίμων στην Ελλάδα. Σήμερα το εργαστήριο δραστηριοποιείται σε διάφορα ερευνητικά προγράμματα, παρέχει εξειδικευμένες υπηρεσίες στην ανάλυση τροφίμων τόσο σε δημόσιους φορείς όσο και σε επιχειρήσεις και απαρτίζεται από τρία μέλη ΔΕΠ. Οι κύριες ερευνητικές του δραστηριότητες είναι:
                            <ul>
                                <li>Ποιοτικός και ποσοτικός προσδιορισμός βιοδραστικών συστατικών (πολυφαινόλες, βιταμίνες, καροτενοειδή) τροφίμων (π.χ. αφεψημάτων, οίνων, ζύθων, φυτικά προϊόντα) και αιθερίων ελαίων και μελέτη της αντιοξειδωτικής τους ικανότητας.</ li>
                                <li>Μελέτη των επιπέδων βαρέων μετάλλων (όπως Cd, Pb, Hg, As) σε τρόφιμα Ελληνικής προέλευσης (Φυτικά και Ζωϊκά) και σε μεταποιημένα τρόφιμα (π.χ. κονσερβοποιημένα) καθώς και μετανάστευση τους απο τη συσκευασία στο τρόφιμο.</ li>
                                <li>Μελέτη των παραγόντων που επηρεάζουν την βιοσύνθεση των τοξικών μεταβολιτών των μυκήτων σε αγροτικά προιόντα</ li>
                                <li>Ανάπτυξη και επικύρωση μεθόδων προσδιορισμού μυκοτοξινών στα τρόφιμα.</ li>
                                <li>Ποιοτικός και ποσοτικός προσδιορισμός των λιπιδίων υδρόβιων βρώσιμων οργανισμών (ψαριών και θαλασσινών) [κυρίως των πολυακόρεστων λιπαρών οξέων (EPA, DHA), στερολών, τριγλυκεριδίων, των φωσφολιπιδίων, καροτενοειδών], καθώς και των απαραίτητων μετάλλων για την εκτίμηση της διατροφικής τους αξίας.</ li>
                                <li>Αναλύσεις ποιοτικού ελέγχου γάλακτος, κρέατος, φυτικών προϊόντων (λίπος, πρωτεϊνες, υγρασία, τέφρα, διαιτητικές ίνες).</ li>
                            </ul>
                            Είναι εξοπλισμένο με κατάλληλα επιστημονικά αναλυτικά όργανα για τις αναλύσεις που αναφέρονται στα ΠΕ που συμμετέχει όπως Αέριοχρωματογάφο με ανιχνευτή φλόγας, υγροχρωματογράφο με ανιχνευτή υπεριώδους ορατού, φασματοφωτόμετρα, απλά και ατομικής απορρόφησης με φλόγα, καθώς και άλλες αναλυτικές συσκευές  προσδιορισμού πρωτεϊνών, λίπους, υγρασίας, τέφρας κ.α., Διαθέτει επίσης πλήρως εξοπλισμένο εργαστήριο για μικροβιολογικές αναλύσεις και αναλύσεις τοξινών. Τέλος έχει κατάλληλους χώρους για μελέτη οργανοληπτικών χαρακτηριστικών τροφίμων και ποτών.
                        </Typography>
                    </p>
                    <p>
                        <Typography variant='h6'>Επικοινωνία</Typography>
                        <Typography align='left'>
                            <LocationOn className={classes.communication} />ΠΑΝΕΠΙΣΤΗΜΙΟΥΠΟΛΗ ΖΩΓΡΑΦΟΥ, T.K. 15771, ΑΘΗΝΑ<br />
                            <Phone className={classes.communication} /> ΤΗΛΕΦΩΝΟ ΕΠΙΚΟΙΝΩΝΙΑΣ: 2107274160<br />
                            <Email className={classes.communication} /> <Link href='mailto:harpro@chem.uoa.gr'>harpro@chem.uoa.gr</Link> <br />
                            <Language className={classes.communication} /> <Link href='http://www.elke.uoa.gr/'>Ιστοσελίδα</Link>
                        </Typography>
                    </p>
                </React.Fragment>
                : null
            } */}


            {/* {activeDescription === 6 ?
                <React.Fragment>
                    <p>
                        <Typography variant='h6'>Γενικά στοιχεία</Typography>
                        <Typography align='left'>
                            Α/Α ΦΟΡΕΑ: 7 <br />
                            ΣΥΝΤΟΝΙΣΤΗΣ: ΟΧΙ <br />
                            ΕΠΩΝΥΜΙΑ ΦΟΡΕΑ: ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ-ΕΡΓΑΣΤΗΡΙΟ ΓΑΛΑΚΤΟΚΟΜΙΑΣ <br />
                            ΣΥΝΤΟΜΟΓΡΑΦΙΑ ΦΟΡΕΑ: ΓΠΑ<br />
                            ΕΠΩΝΥΜΙΑ ΚΥΡΙΟΥ ΦΟΡΕΑ ΣΤΟΝ ΟΠΟΙΟ ΑΝΗΚΕΙ: ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ<br />
                        </Typography>
                    </p>
                    <p>
                        <Typography variant='h6'>Συνοπτική παρουσίαση δικαιούχου φορέα</Typography>
                        <Typography align='justify'>
                            Το Εργαστήριο Γαλακτοκομίας ανήκει στο Τμήμα Επιστήμης Τροφίμων και
                            Διατροφής του Ανθρώπου της Σχολής Τροφίμων, Βιοτεχνολογίας και
                            Ανάπτυξης του Γεωπονικού Πανεπιστημίου Αθηνών (ΓΠΑ). Λειτουργεί ως
                            αυτοτελής εκπαιδευτική και ερευνητική μονάδα από το 1962. Έχει την
                            ευθύνη της εκπαίδευσης προπτυχιακών και μεταπτυχιακών φοιτητών,
                            κυρίως του Τμήματος Επιστήμης Τροφίμων και Διατροφής του Ανθρώπου
                            αλλά και άλλων τμημάτων του ΓΠΑ, σε θέματα Επιστήμης και Τεχνολογίας
                            Γάλακτος και Γαλακτοκομικών Προϊόντων, όπως επίσης και Βιοχημείας
                            Τροφίμων. Το Εργαστήριο Γαλακτοκομίας διαθέτει μόνιμο ειδικευμένο
                            επιστημονικό και τεχνικό προσωπικό, πλήρως ανακαινισμένη κτιριακή
                            υποδομή (1.200 τ.μ.) καθώς και σύγχρονο επιστημονικό και τεχνολογικό
                            εξοπλισμό. Περιλαμβάνει άνετους εργαστηριακούς χώρους, τόσο
                            εκπαιδευτικούς όσο και ερευνητικούς, καθώς επίσης και πιλοτικό
                            τυροκομείο με θαλάμους ωρίμανσης και συντήρησης τυριών. Ο
                            επιστημονικός εξοπλισμός του Εργαστηρίου περιλαμβάνει όλα τα μικρά και
                            μεγάλα όργανα ενός σύγχρονου εργαστηρίου Χημείας και Μικροβιολογίας
                            Γάλακτος καθώς επίσης Βιοχημείας και Μοριακής Βιολογίας.
                        </Typography>
                    </p>
                    <p>
                        <Typography variant='h6'>Επικοινωνία</Typography>
                        <Typography align='left'>
                            <LocationOn className={classes.communication} />ΙΕΡΑ ΟΔΟΣ 75 , T.K. 11855, ΑΘΗΝΑ<br />
                            <Phone className={classes.communication} /> ΤΗΛΕΦΩΝΟ ΕΠΙΚΟΙΝΩΝΙΑΣ: 2105204661<br />
                            <Email className={classes.communication} /> <Link href='mailto:et@aua.gr'>et@aua.gr</Link> <br />
                            <Language className={classes.communication} /> <Link href='https://www2.aua.gr/el'>Ιστοσελίδα</Link>
                        </Typography>
                    </p>
                </React.Fragment>
                : null
            } */}
        </React.Fragment>
    )
}